'use client'

import { DOC_TYPES } from '@/data'
import { useParams, usePathname } from 'next/navigation'

const useCurrentPage = () => {
  const params = useParams()
  const paramsAsArray = Object.keys(params)
  const currentPath = usePathname()
  const currentLanguage = params.language

  let currentDocType = DOC_TYPES.PAGE
  let currentSlug: string | string[] | undefined = params?.slug || ''

  if (currentPath.split('/').filter(item => item).length === 2 && params?.slug === undefined) {
    currentSlug = currentPath.split('/').filter(item => item)[1]
  } else if (paramsAsArray.includes('blogPostSlug')) {
    currentDocType = DOC_TYPES.BLOG_POST
    currentSlug = params.blogPostSlug
  } else if (paramsAsArray.includes('restaurantSlug')) {
    currentDocType = DOC_TYPES.LOCATION
    currentSlug = params.restaurantSlug
  } else if (paramsAsArray.includes('menuItemSlug')) {
    currentDocType = DOC_TYPES.MENU_ITEM
    currentSlug = params.menuItemSlug
  }

  return { currentPath, currentLanguage, currentDocType, currentSlug }
}

useCurrentPage.displayName = 'useCurrentPage'

export default useCurrentPage
